import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { EuaPriceListResponse, SpotPrice } from '../models/backend';
import { Bonus } from '../stores/client-data.store';

interface MaxMarginResponse {
  data: { id: number; documentId: string; amount: number };
}

interface BonusesResponse {
  data: Bonus[];
}

export interface BonusCalcResponse {
  status: number;
  bonusAsk: number;
  bonusBid: number;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PricesService {
  private http = inject(HttpClient);
  private environment = inject(ENVIRONMENT);

  getSpotPrice() {
    return this.http.get<{ status: number; lastPrice: SpotPrice; offset?: number }>(
      `${this.environment.cmsApiUrl}/eua-price/spot`,
    );
  }

  getHistoryPrice() {
    return this.http.get<EuaPriceListResponse>(
      `${this.environment.cmsApiUrl}/eua-prices?pagination[page]=1&pagination[pageSize]=1&sort=createdAt:desc`,
    );
  }

  getMaxMargin() {
    return this.http.get<MaxMarginResponse>(`${this.environment.cmsApiUrl}/max-margin`);
  }

  getBonuses() {
    return this.http.get<BonusesResponse>(`${this.environment.cmsApiUrl}/bonuses`);
  }

  getMyBonuses() {
    return this.http.get<BonusCalcResponse>(
      `${this.environment.cmsApiUrl}/eua-price/my-bonuses`,
    );
  }

  getUserBonuses(userDocumentId: string) {
    return this.http.get<BonusCalcResponse>(
      `${this.environment.cmsApiUrl}/eua-price/user-bonuses/${userDocumentId}`,
    );
  }
}
